import { Icon } from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import ShopifyStoreDetails from "./ShopifyStoreDetails/ShopifyStoreDetails";
import StoreDetailSettings from "./StoreDetails/StoreDetailSettings";
import { DnsSettingsIcon, SettingsIcon } from "@shopify/polaris-icons";

const TabSettings = () => {
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    [],
  );

  const tabs = [
    {
      id: "shopify-store-settings",
      content: "Shopify Store Settings",
      icon: SettingsIcon,
    },
    {
      id: "google-settings",
      content: "Google Settings",
      icon: DnsSettingsIcon,
    },
  ];

  const tabContent = [<ShopifyStoreDetails />, <StoreDetailSettings />];

  return (
    <div>
      <div className="app-page-hero">
        <div>
          <div className="app-page-hero__eyebrow">
            <Icon source={SettingsIcon} tone="base" />
            Configuration
          </div>
          <h1 className="app-page-hero__title">Settings</h1>
          <p className="app-page-hero__subtitle">
            Control Shopify feed defaults and Google Merchant Center submission
            preferences.
          </p>
        </div>
        <div className="app-page-hero__meta">
          <span className="app-chip app-chip--info">
            {tabs[selected].content}
          </span>
        </div>
      </div>

      <div className="settings-tabs" role="tablist" aria-label="Settings tabs">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected === index}
            className={`settings-tab${selected === index ? " is-active" : ""}`}
            onClick={() => handleTabChange(index)}
          >
            <Icon source={tab.icon} tone="base" />
            <span>{tab.content}</span>
          </button>
        ))}
      </div>

      {tabContent[selected]}
    </div>
  );
};

export default TabSettings;
